import { Routes } from '@angular/router';
import { CasestudiesContainerComponent } from "./casestudies-container/casestudies-container.component";
import { AiPoweredRecruitmentToolComponent } from './ai-powered-recruitment-tool/ai-powered-recruitment-tool.component';
import { AidrivenInsuranceappComponent } from './aidriven-insuranceapp/aidriven-insuranceapp.component';
import { CasestudiesCoverComponent } from './casestudies-cover/casestudies-cover.component';
import { CustomSharepointComponent } from './custom-sharepoint/custom-sharepoint.component';
import { CustomWebdevelopmentComponent } from './custom-webdevelopment/custom-webdevelopment.component';
import { DataObfuscationComponent } from './data-obfuscation/data-obfuscation.component';
import { GuardDogPageComponent } from './guard-dog-page/guard-dog-page.component';
import { ImplementedDatamigrationComponent } from './implemented-datamigration/implemented-datamigration.component';
import { MeetBusinessComponent } from './meet-business/meet-business.component';
import { OrganizedPortalComponent } from './organized-portal/organized-portal.component';
import { RetireplanAdvisoryComponent } from './retireplan-advisory/retireplan-advisory.component';
import { SaasLaunchComponent } from './saas-launch/saas-launch.component';
import { SmartIntegrationComponent } from './smart-integration/smart-integration.component';
import { UnifiedInsuranceComponent } from './unified-insurance/unified-insurance.component';
import { UnifiedPortalComponent } from './unified-portal/unified-portal.component';

export const caseStudiesRoutes: Routes = [
    {path: '', component: CasestudiesContainerComponent, children: [
        {path:'case-study',component:CasestudiesCoverComponent,  data: {
    title: 'Inspiring stories on our business approach | Case study',
    description: 'Discover the handpicked case studies on innovative & advanced technologies that have optimized various business processes. ',
    keywords: 'Case Study',
    image:'',
    url:'https://www.kalpitatechnologies.com/case-studies'
  }},
  { path: "custom-sharepoint", component: CustomSharepointComponent,
  data: {
    title: 'Enhancing Employee Engagement: Custom SharePoint Interface Case Study',
    description: 'Explore how our custom-built SharePoint interface revolutionized employee engagement, driving productivity and collaboration in the organization.',
    keywords: 'Case Study',
    image:'',
    url:'https://www.kalpitatechnologies.com/case-studies/custom-sharepoint'
  } },
  { path: "guard-dog-page", component: GuardDogPageComponent,
  data: {
    title: 'Revolutionize Monitoring: Introducing our 100% Web-based Alert-based Cellular Monitoring System',
    description: 'Discover how our easy-to-use, web-based cellular monitoring system ensures real-time alerts, ready for deployment, safeguarding your assets effortlessly.',
    keywords: 'Case Study',
    image:'',
    url:'https://www.kalpitatechnologies.com/case-studies/guard-dog-page'
  }  },
  { path: "implemented-datamigration", component: ImplementedDatamigrationComponent },
  { path: "meet-business", component: MeetBusinessComponent,
  data: {
    title: 'Unlock Success: Achieve Business Goals with Proven ERP Methodologies',
    description: 'Discover how our tailored ERP methodologies can propel your business forward. From implementation to optimization, we have the solutions you need to meet your objectives.',
    keywords: 'Case Study',
    image:'',
    url:'https://www.kalpitatechnologies.com/case-studies/meet-business'
  }   },
  { path: "organized-portal", component: OrganizedPortalComponent,
    data: {
      title: 'Enhancing eCommerce Efficiency: Streamlined Portal with Managed Access & Payment Gateways',
      description: 'Discover how our organized eCommerce portal, featuring 3 roles of managed access and seamless payment gateways, optimized operations and enhanced user experience.',
      keywords: 'eCommerce',
      image:'',
      url:'https://www.kalpitatechnologies.com/case-studies/organized-portal'
    }
   },
  { path: "saas-launch", component: SaasLaunchComponent,
    data: {
    title: 'Launch Your Ecommerce Store with Our SaaS Solution',
    description: 'Discover how our SaaS product empowers businesses to effortlessly launch fully functional ecommerce stores. Streamline your online selling journey today!',
    keywords: 'saas',
    image:'',
    url:'https://www.kalpitatechnologies.com/case-studies/saas-launch'
  } },
  { path: "smart-integration", component: SmartIntegrationComponent,
    data: {
      title: 'Enhancing Workflow Efficiency with a Smart Integration Engine',
      description: 'Discover how our smart integration engine centralized workflows, ensured secure corporate network communications, and streamlined operations effectively.',
      keywords: 'Smart Integration Engine',
      image:'',
      url:'https://www.kalpitatechnologies.com/case-studies/smart-integration'
    }
   },
  { path: "unified-portal", component: UnifiedPortalComponent,
    data: {
      title: 'Building a Unified Customer Portal for Consistent Brand Engagement',
      description: 'Discover how we created a unified portal, connecting customers seamlessly while delivering a consistent brand message. Learn more about our success story!',
      keywords: 'unified portal,brand engagement',
      image:'',
      url:'https://www.kalpitatechnologies.com/case-studies/unified-portal'
    }
   },
  { path: "data-obfuscation", component: DataObfuscationComponent,
  data: {
    title: 'Kalpita Data Obfuscation Tool to Secure Sensitive Data',
    description: 'Protect sensitive data with our Kalpita Data Obfuscation Tool. Learn how to securely mask information to prevent unauthorized access. Safeguard your data now!',
    keywords: 'data obfuscation, obfuscation',
    image:'',
    url:'https://www.kalpitatechnologies.com/case-studies/data-obfuscation'
  }},
  { path: "custom-web-development", component: CustomWebdevelopmentComponent,
  data: {
    title: 'End-to-end Custom Website Development from Design to Hosting',
    description: 'Get to know how we helped our client with custom wesbite development ',
    keywords: 'custom website development',
    image:'',
    url:'https://www.kalpitatechnologies.com/case-studies/custom-web-development'
  } },
  { path: "us-retirement-plan", component: RetireplanAdvisoryComponent,
    data: {
      title: 'Innovative Solutions for Retirement Planning and Pricing Strategies',
      description: 'Kalpita Technologies optimized retirement plan & pricing strategies, automated data extraction, and improved operational efficiency for a finance advisory firm.',
      keywords: 'retirement planning, pricing strategy, retirement plan, financial advisory, data extraction',
      image:'',
      url:'https://www.kalpitatechnologies.com/case-studies/us-retirement-plan'
    } },
    { path: "aidriven-insurance-application", component: AidrivenInsuranceappComponent,
      data: {
        title: 'AI-Driven Insurance Application Accelerator | Case Study',
        description: 'Kalpita Technologies\' AI-driven Insurance Accelerator optimized onboarding, minimized manual tasks, and accelerated processing through automated questionnaires.',
        keywords: 'Customer Onboarding platform, insurance ai-driven platform​, application accelerator, Insurance, smart insure',
        image:'',
        url:'https://www.kalpitatechnologies.com/case-studies/aidriven-insurance-application'
      } },
      { path: "unified-system-insurance", component: UnifiedInsuranceComponent,
        data: {
          title: 'Automated Billing System for Insurance | Case Study',
          description: 'Kalpita Technologies built an automated billing system for Insurance that automates billing logic, manages billing status, and enhances user experience.',
          keywords: 'automated billing, automated billing system, billing status',
          image:'',
          url:'https://www.kalpitatechnologies.com/case-studies/unified-system-insurance'
      } },
      { path: "ai-powered-recruitment-tool", component: AiPoweredRecruitmentToolComponent,
        data: {
          title: 'AI-Powered Recruitment Software with RAG Chatbot & Azure Search',
          description: 'Explore Kalpita Technologies intelligent recruitment software featuring RAG chatbot integration, Azure AI Search indexing, automated workflows, & centralized candidate tracking, designed to modernize and streamline hiring processes.',
          keywords: 'AI-powered recruitment software, RAG chatbot, Azure AI Search, automated hiring process, recruitment workflow, candidate tracking, recruitment tool, hiring automation, legacy system challenges, recruitment software solution, centralized recruitment system',
          image:'',
          url:'https://www.kalpitatechnologies.com/case-studies/ai-powered-recruitment-tool'
      } },

    ]}
]